import { createMiddleware } from "@tanstack/react-start";

const PREVIEW_ZONES = [
  "lovableproject.com",
  "lovableproject-dev.com",
  "lovable.app",
  "gpt-eng.com",
  "gptengineer.run",
];

/** True when a Supabase session might exist, so the auth client is worth loading. */
function mayHaveSupabaseSession(): boolean {
  if (typeof window === "undefined") return false;
  const host = location.hostname;
  if (PREVIEW_ZONES.some((zone) => host === zone || host.endsWith(`.${zone}`))) return true;
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith("sb-") && key.includes("auth-token")) return true;
    }
  } catch {
    return false;
  }
  return false;
}

/**
 * Attaches a bearer token to server function calls when a session exists.
 * The Supabase client stays out of the initial bundle: this page has no login,
 * and loading auth/realtime/storage on every visit is unused JavaScript.
 */
export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    if (!mayHaveSupabaseSession()) return next();
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
